import { render } from "./FormPhone.vue?vue&type=template&id=1754b94d"
import script from "./FormPhone.vue?vue&type=script&lang=js"
export * from "./FormPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__